// extracted by mini-css-extract-plugin
export default {"wrapper":"add-mailbox-modal_wrapper__OwExH","footer":"add-mailbox-modal_footer__gS7Cn"};